/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('ServiceSelectorCtrl', ["$scope", "CategoryData", "CategoryView", function($scope,CategoryData,CategoryView)
{
    $scope.setCurrentCategory  = function(categoryView)
    {
        $scope.dd.view.cCategoryView = categoryView;
    };

}]);


// WEBPACK FOOTER //
// ./js/controllers/pro/service/ServiceSelectorCtrl.js